
      var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgTime = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 19,
  height: 19,
  viewBox: "0 0 19 19"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".time_2a41d8ea27ec4471__cls-1{fill:none;stroke:#4a4a4a;stroke-linecap:round;stroke-linejoin:round}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "time_2a41d8ea27ec4471__Group_800",
  "data-name": "Group 800",
  transform: "translate(.5 .852)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "time_2a41d8ea27ec4471__Ellipse_1",
  "data-name": "Ellipse 1",
  className: "time_2a41d8ea27ec4471__cls-1",
  cx: 9,
  cy: 9,
  r: 9,
  transform: "translate(0 -.352)"
}), /*#__PURE__*/React.createElement("path", {
  id: "time_2a41d8ea27ec4471__Path_224",
  "data-name": "Path 224",
  className: "time_2a41d8ea27ec4471__cls-1",
  d: "M12 7v5.17l2.068 3.1",
  transform: "translate(-2.694 -2.864)"
}))));

      const __svgRaw = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"19\" height=\"19\" viewBox=\"0 0 19 19\">\r\n    <defs>\r\n        <style>\r\n            .cls-1{fill:none;stroke:#4a4a4a;stroke-linecap:round;stroke-linejoin:round}\r\n        </style>\r\n    </defs>\r\n    <g id=\"Group_800\" data-name=\"Group 800\" transform=\"translate(.5 .852)\">\r\n        <circle id=\"Ellipse_1\" data-name=\"Ellipse 1\" class=\"cls-1\" cx=\"9\" cy=\"9\" r=\"9\" transform=\"translate(0 -.352)\"/>\r\n        <path id=\"Path_224\" data-name=\"Path 224\" class=\"cls-1\" d=\"M12 7v5.17l2.068 3.1\" transform=\"translate(-2.694 -2.864)\"/>\r\n    </g>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/time.2a41d8ea27ec447122eeeeb6c5f63865.svg"),
        {
          React: SvgTime,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      